import { useIsFeatureRolloutEnabled } from '@ms/yammer-hooks/dist/featureRollouts';

import type { UseUIFeatureCheck } from '../types';

export const useIsChatEnabled: UseUIFeatureCheck = () => useIsFeatureRolloutEnabled('TeamsChatButton');
